import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import saveIcon from "../../../../icons/common/save.png";
import closeIcon from "../../../../icons/common/close.png";
import activeIcon from "../../../../icons/common/active.png";
import inactiveIcon from "../../../../icons/common/inactive.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  messageManagemetnSettingsEndPoint,
  updatemessageManagementSettingsEndPoint,
} from "../../utils";
import axios from "axios";
import { setRowData } from "../../../grid/gridReducer";
import {
  setMobileMsgData,
  setReclaimScanMsgData,
} from "../../settingsReducers";
import notify from "../../../../services/toasterService";
import { RootState } from "../../../../redux/store";

const PreviewReclaimScan = () => {
  const dispatch = useDispatch();

  const languageData = useSelector(
    (state: RootState) => state.settingsReducer.languagesList
  );

  /* Get selected data from Grid Reducer */
  const selRowData = useSelector(
    (state: RootState) => state.gridReducer.selectedRowData
  );

  const [mobileInfo, setMobileInfo] = useState<any[]>([]);
  const [reclaimScanInfo, setRecliamScanInfo] = useState<any[]>([]);

  useEffect(() => {
    console.log();
    if (selRowData && selRowData?.length > 0) {
      setRecliamScanInfo(selRowData);
    }
    // Write for onload
  }, [selRowData]);

  const msgFieldFocusOut = (event: any, key: any) => {
    setMobileInfo({ ...mobileInfo[0], [key]: event.target.value });
  };

  const msgTextFieldFocusOut = (value: any, key: any) => {
    setMobileInfo({ ...mobileInfo[0], [key]: value });
  };

  const reclaimScanTextFieldFocusOut = (value: any, key: any) => {
    setRecliamScanInfo([{ ...reclaimScanInfo[0], [key]: value }]);
  };

  const reclaimScanFocusOut = (event: any, key: any) => {
    setRecliamScanInfo([{ ...reclaimScanInfo[0], [key]: event.target.value }]);
  };

  /**
   * Changing status for Preview selected tabs
   * @param flag - true/false
   */
  const changeStatusForRowData = (flag: any) => {
    if (flag === false) {
      setRecliamScanInfo([
        { ...reclaimScanInfo[0], activeForGrid: "Inactive" },
      ]);
    } else {
      setRecliamScanInfo([{ ...reclaimScanInfo[0], activeForGrid: "Active" }]);
    }
  };

  const clearPreview = () => {
    dispatch(setRowData([]));
  };

  // const getSettingsMsgMgmtTabs = async (tabName: any) => {
  //     const endPointURL = messageManagemetnSettingsEndPoint(tabName);
  //     await axios.get(endPointURL).then((res) => {
  //        if (tabName === "Reclaim Scan") {
  //             dispatch(setReclaimScanMsgData(res.data));

  //         } else if (tabName === "Mobile") {
  //             dispatch(setMobileMsgData(res.data));
  //         }

  //     }).catch((err) => {
  //         notify('Failed to update data', 'error');
  //     });
  // }

  /**
   * PUT web service methods for Location setting tabs
   * @param data - Tab Name
   */
  const updateMsgMngmtSettingsTabApi = async (data: any) => {
    const endPointURL = updatemessageManagementSettingsEndPoint(
      data.tabApiName,
      data.id
    );
    let body = {
      id: data.id,
      messageType: data.type,
      languageKey: data.languageKey,
      messageText: data.text,
    };
    const status = data.activeForGrid.toLowerCase();
    if (status === "active") {
      Object.assign(body, { active: true });
    } else {
      Object.assign(body, { active: false });
    }
    await axios
      .put(endPointURL, body)
      .then((res) => {
        notify(data.tabApiName + " updated successfully", "success");
        getSettingsMsgMgmtTabs(data.tabApiName);
      })
      .catch((err) => {
        console.log(err, "Reclaim Scan tab");
        notify("Failed to update" + data.tabApiName, "error");
      });
  };

  const getSettingsMsgMgmtTabs = async (tabName: any) => {
    const endPointURL = messageManagemetnSettingsEndPoint(tabName);
    await axios
      .get(endPointURL)
      .then((res) => {
        //  clearPreview()
        if (tabName === "Reclaim Scan") {
          dispatch(setReclaimScanMsgData(res.data));
        } else if (tabName === "Mobile") {
          dispatch(setMobileMsgData(res.data));
        }
      })
      .catch((err) => {
        console.log(err, "Reclaim Scan tab");
        notify("Failed to update Reclaim Scan data", "error");
      });
  };

  // const updateMsgMngmtSettingsTabApi = async (data: any) => {
  //     console.log(data);
  //     const endPointURL = updatemessageManagementSettingsEndPoint(data.tabApiName, data.id);
  //     let body = {};
  //         body = {
  //             id: data.id, messageType: data.type, languageKey: data.languageKey, messageText: data.text
  //         }
  //     const status = data.activeForGrid.toLowerCase();
  //     if (status === 'active') {
  //         Object.assign(body, { active: true })
  //     } else {
  //         Object.assign(body, { active: false })
  //     }
  //     await axios.put(endPointURL, body).then(
  //         (res) => {
  //             notify(data.tabApiName + ' Updated Successfully', 'success');
  //             getSettingsMsgMgmtTabs(data.tabApiName);
  //         }
  //     ).catch((err) => {
  //         notify('Failed to update data', 'error');
  //     });
  // }

  const footerPreview = (data: any) => {
    return (
      <div className="col-sm-12 px-0 pt-5 ">
        <div className="col-sm-6 col-md-6 col-lg-5 preview-Key ">
          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left"
            onClick={() => updateMsgMngmtSettingsTabApi(data)}
          >
            <img src={saveIcon} alt="Save" />
          </ButtonComponent>

          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left ml-3"
            onClick={() => clearPreview()}
          >
            <img src={closeIcon} alt="Close" />
          </ButtonComponent>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-7 preview-value pt-3">
          <p className="preview-status">
            {data?.activeForGrid === "Active" ||
            data?.activeForGrid === "active" ? (
              <span>
                <img
                  src={activeIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(false)}
                />
                &nbsp; &nbsp; Active
              </span>
            ) : (
              <span>
                <img
                  src={inactiveIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(true)}
                />
                &nbsp; &nbsp; Inactive
              </span>
            )}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div>
      {reclaimScanInfo && reclaimScanInfo.length > 0 ? (
        <div className="col-sm-12 px-5 py-4 preview-details  ">
          <div className="col-sm-12 px-0 pt-4 ">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
              Message ID
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value pl-5">
              {reclaimScanInfo[0]?.id}
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
              Message Type
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              <select
                className="form-control border-none storeNumber"
                value={reclaimScanInfo[0]?.type}
                onChange={(e) => reclaimScanFocusOut(e, "type")}
              >
                {/* <option value={reclaimScanInfo[0]?.type}>{reclaimScanInfo[0]?.type}</option> */}
                <option value="Success">Success</option>
                <option value="Information">Information</option>
                <option value="Warning">Warning</option>
                <option value="Error">Error</option>
              </select>
            </div>
          </div>
          <div className="col-sm-12 px-0 pt-4">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
              Language
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              <select
                className="form-control border-none storeNumber"
                value={reclaimScanInfo[0]?.languageKey}
                onChange={(e) => reclaimScanFocusOut(e, "languageKey")}
              >
                {/* <option value={reclaimScanInfo[0]?.languageKey}>{reclaimScanInfo[0]?.languageKey}</option> */}
                {languageData?.map((ld) => (
                  <option value={ld?.isoLongCode}>{ld?.isoLongCode}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-sm-12 p-0 mb-auto">
            <hr className="divider" />
          </div>

          <div className="col-sm-12 px-0">
            <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
              Msg Text
            </div>
            <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
              {/* <textarea className="notes-preview" name="" id="" rows={8}
                                onChange={(e) => reclaimScanTextFieldFocusOut(e.target.value, 'text')}>
                                {reclaimScanInfo[0]?.text}
                            </textarea> */}
              <textarea
                className="notes-preview"
                id=""
                rows={8}
                value={reclaimScanInfo[0]?.text}
                onChange={(e) =>
                  reclaimScanTextFieldFocusOut(e.target.value, "text")
                }
              ></textarea>
            </div>
          </div>

          <div className="col-sm-12 px-0 pt-5 pb-4">
            {footerPreview(reclaimScanInfo[0])}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default PreviewReclaimScan;
